import React from 'react'
import {
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
} from '@mui/material'
import { usePromptSelect } from './hooks'

export function PromptSelect() {
  const {
    selectedPromptId,
    selectedPrompt,
    filteredPrompts,
    loading,
    handlePromptChange,
  } = usePromptSelect()

  return (
    <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
      <Box sx={{ flex: 1 }}>
        <FormControl fullWidth size="small">
          <InputLabel id="prompt-select-label">Prompt</InputLabel>
          <Select
            labelId="prompt-select-label"
            id="prompt-select"
            value={selectedPromptId || ''}
            label="Prompt"
            onChange={(e: SelectChangeEvent) =>
              handlePromptChange(e.target.value || null)
            }
          >
            {loading ? (
              <MenuItem disabled>Loading prompts...</MenuItem>
            ) : filteredPrompts.length === 0 ? (
              <MenuItem disabled>No prompts available</MenuItem>
            ) : (
              filteredPrompts.map(({ area: promptArea, promptId }) => (
                <MenuItem
                  dense
                  key={`${promptArea}-${promptId}`}
                  value={promptId}
                >
                  {`${promptArea} - ${promptId}`}
                </MenuItem>
              ))
            )}
          </Select>
        </FormControl>
      </Box>
      <Box sx={{ flex: 1 }}>
        <TextField
          value={selectedPrompt?.metadata.description || ''}
          multiline
          rows={2}
          variant="outlined"
          size="small"
          fullWidth
          label="Description"
          slotProps={{
            input: {
              readOnly: true,
            },
          }}
        />
      </Box>
    </Box>
  )
}
